export const TrustToTrustInfoContent = {
  pageTitle: 'Provide some information about the current trust account',
  continueButton: 'Continue',
  trusteeButton: 'Add/remove a trustee',
  trustNameLabel: 'Full legal trust name',
  trustDateLabel: 'Current trust date',
  ssnOrEINLabel: 'SSN or EIN currently on file',
  trusteeCardTitle: 'Now let us know what trustee information needs to updated',
  requiredError: 'This field is required',
  invalidFormat:
    "The SSN or EIN you've entered isn't in the correct format. Please ensure that you're entering a valid number and try again.",
  rightRailAccordion: [
    {
      title: `What if I need to add multiple trustees?`,
      content: `At this time, we can't collect the extra signatures needed through this process and will need you to call 877-662-7447 (M–F, 8 a.m. to 8 p.m., ET) to begin this request.`,
    },
  ],
};
